import React, { useState } from 'react';
import FieldOfCareSelect from '../../../Base/Components/Inputs/FieldOfCareSelect/FieldOfCareSelect';

interface Props {
	name: string;
	isRequired?: boolean;
	placeholder?: string;
	value?: string;
	onChange?: (value: string) => void;
}

const WorkplaceFieldOfCarePHP: React.FC<Props> = ({ name, value }) => {
	const [val, setVal] = useState(value);
	const handleOnChange = (value: any) => {
		setVal(value?.value);
	};

	return (
		<>
			<FieldOfCareSelect value={val} onChange={handleOnChange} />
			<input
				style={{ display: 'none' }}
				name={name}
				value={val}
				onChange={() => {}}
			/>
		</>
	);
};

export default WorkplaceFieldOfCarePHP;
